"use client"

import { PopularityIndicator } from "./PopularityIndicator"
import { TX_CHAIN_EXPLORER } from "@/hooks/coins/constants"
import { ExternalLink } from "lucide-react"
import { Address } from "viem"

type Props = {
  tokenAddress: Address
  ethPrice: number
}

export function PopularityWithEtherscan({ tokenAddress, ethPrice }: Props) {
  return (
    <div className="flex items-center justify-between">
      <PopularityIndicator
        tokenAddress={tokenAddress}
        ethPrice={ethPrice}
      />
      
      <a
        href={`${TX_CHAIN_EXPLORER.replace('/tx/', '/token/')}${tokenAddress}`}
        target="_blank"
        rel="noopener noreferrer"
        className="flex items-center gap-1 text-sm text-blue-600 hover:text-blue-800 transition-colors"
      >
        Etherscan
        <ExternalLink size={12} />
      </a>
    </div>
  )
}
